import { Record, List } from 'immutable';
import PaymentMethod from './PaymentMethod';
import Address from './Address';
import CustomerIdentifier from './CustomerIdentifier';

const CustomerDefaults = {
  id: null,
  name: '',
  email: '',
  phone: '',
  identifiers: new List(),
  shipping_addresses: new List(),
  payment_methods: new List(),
  submittedOrderWithRememberMe: false,
  preferences: {},
  notification_settings: [],
  hasPassword: false
};

class Customer extends Record(CustomerDefaults) {
  constructor(values) {
    values.identifiers = (new List(values.identifiers)).map((id) => {return new CustomerIdentifier(id);});
    values.shipping_addresses = (new List(values.shipping_addresses)).map((sa) => {return new Address(sa);});
    values.payment_methods = (new List(values.payment_methods)).map((pm) => {return new PaymentMethod(pm);});

    super(values);
  }

  get first_name() {
    let name = this.name || '';
    let fname = name.substr(0, name.indexOf(' '));
    fname = fname || name;
    return fname;
  }

  authStatus() {
    return this.isSignedIn() ? (this.getVerifiedEmailIdentifier() ? 'has_verified_email' : 'has_email') : 'anonymous';
  }

  isSignedIn() {
    return !!this.identifiers.find(identifier => {
      return identifier.type === 'email_identifier';
    });
  }

  getVerifiedEmailIdentifier() {
    return this.identifiers.size && this.identifiers.find((id) => {
      return id.get('type') === 'email_identifier' && id.get('verified');
    });
  }
}

export default Customer;



// WEBPACK FOOTER //
// banquet/models/Customer.js